import { Message } from 'element-ui';
import axios from 'axios';
import { getToken, removeToken } from '@/utils';
import envConfig from '@/config';

const authURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_AUTH_URL`];
const instance = axios.create({
  baseURL: authURL,
  timeout: 300000,
});

instance.interceptors.request.use((request) => {
  /* eslint-disable */
  request.params = request.params || {};
  request.params.server_name="SMART";
  return request;
});

if (envConfig.env === 'development') {
  // instance.interceptors.request.use((request) => {
  //   request.baseURL += `/${request.method}`;
  //   return request;
  // });
  instance.interceptors.response.use((response) => {
    /* eslint-disable no-console */
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

instance.interceptors.request.use((request) => {
  
  /* eslint-disable */
  const ticket = getToken();
  if (ticket) {
    request.headers.common['Authorization'] = `Bearer ${ticket}`;
    request.headers['Authorization'] = `Bearer ${ticket}`;
  }
  // request.headers.common['version'] = envConfig.version;
  request.withCredentials = true;
  /* eslint-enable */
  return request;
});
instance.interceptors.response.use(
  async (response) => {
    // 阻止options
    if (response.config.method.toLowerCase() === 'options') return false;
    // 阻止非200状态
    if (response.status !== 200) return Promise.reject();

    // 目前后端组规范将所有请求统一返回200，以code字段表示真实http状态码
    // warning 智能云后台默认成功请求时返回code:0  权限管理系统则返回code:200  可以用response.request.url区分, 现在先偷懒
    const { to } = response.config;
    const meta = (to || {}).meta || {};
    // 无需登录,返回response.data：meth.auth===0||response.data.code不在权限状态码名单之内
    if (meta.auth === 0 || ![401].some((itemCode) => itemCode === response.data.code)) {
      return response.data;
    }

    // 移除token,调用登录
    removeToken();
    window.location.href = `${authURL}/riskcontrol/oauth/login?redirect=${window.location.protocol}//${window.location.host}`;
    // await store.dispatch('user/LogOut', 'local');
    return Promise.reject(response);
  },
  (error) => {
    console.trace(error.message);
    console.log(error);
    window.location.href = `${authURL}/riskcontrol/oauth/login?redirect=${window.location.protocol}//${window.location.host}`;
    Message.error({
      content: '操作失败',
      duration: 3,
    });
    return Promise.reject(error);
  }
);

export default instance;
